/**
 * @file 套餐卡片组件
 */
import React, {useCallback} from 'react';
import {BenefitList} from './BenefitList';
import RollingNumber from './RollingNumber';
import styles from './LevelCard.module.less';
import {GoodValueImgUrl} from './constants';
import type {MemberLevelItem} from '@/services/commerce/membership/interface';
import {MemberLevelValue} from '@/services/commerce/type';
import Button from '@/components/common/Button';
import Icon from '@/components/common/Icon';
import {fenToYuan} from '@/utils/money';
import {createCx} from '@/utils/cx';

const cx = createCx(styles);

interface LevelCardProps {
    level: MemberLevelItem;
    showSubscribeTag?: boolean;
    onClick: () => void;
}

export const LevelCard: React.FC<LevelCardProps> = ({level, showSubscribeTag, onClick}) => {
    // 处理订阅事件
    const handleSubscribe = useCallback(() => {
        onClick();
    }, [onClick]);

    return (
        <div className={styles.planCard} data-card={level.memberLevel}>
            <div className={styles.cardContent}>
                {/* 等级图标和名称 */}
                <div className={styles.header}>
                    <div className={styles.levelNameWrapper}>
                        <div className={styles.levelName}>{level.levelName}</div>
                        {showSubscribeTag && <span className={styles.currentTag}>当前订阅</span>}
                    </div>
                    <div>
                        {!showSubscribeTag && level.memberLevel === MemberLevelValue.FLAGSHIP && (
                            <img
                                src={GoodValueImgUrl}
                                alt="最超值"
                                className={styles.goodValueTag}
                            />
                        )}
                    </div>
                </div>

                {/* 价格 */}
                <div className={styles.price}>
                    <span className={styles.symbol}>¥</span>
                    <span className={styles.current}>
                        <RollingNumber value={fenToYuan(level.sku.sellPrice)} />
                    </span>
                    <span>/{level.sku.unit ?? '月'}</span>
                    <span className={styles.original}>¥{fenToYuan(level.sku.originPrice)}</span>
                </div>

                {/* 积分 */}
                <div className={styles.points}>
                    <div className={styles.pointsNum}>
                        <Icon name="AijBasicJifen" size={12} />
                        <RollingNumber value={level.sku.pointPerMonth} />
                        <span>积分/月</span>
                    </div>
                    <div className={styles.pointsDescription}>
                        <span>最多生成约 </span>
                        <span>{level.sku.imageCount}</span>
                        <span>张图或 </span>
                        <span>{level.sku.videoCount}</span>
                        <span>条视频</span>
                    </div>
                </div>

                {/* 订阅按钮 */}
                <Button
                    className={cx('button', level.disableSubscribe && 'btnDisable')}
                    onClick={handleSubscribe}
                    disabled={level.disableSubscribe}
                >
                    {level.buttonText}
                </Button>

                {/* 权益列表 */}
                <BenefitList benefits={level.benefits} />
            </div>
        </div>
    );
};
